import HundredBricksAPIError from '../../HundredBricksAPIError';
class InvestorFeedError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('InvestorFeedError', ...args);
    }
}
export default InvestorFeedError;
